import { render, staticRenderFns } from "./overtime_rule_tpl.vue?vue&type=template&id=36634042&"
import script from "./overtime_rule_tpl.vue?vue&type=script&lang=js&"
export * from "./overtime_rule_tpl.vue?vue&type=script&lang=js&"
import style0 from "./overtime_rule_tpl.vue?vue&type=style&index=0&id=36634042&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports